<template>
    <div>
        <toggle-action-data v-model="data.use_event_custom_attribute"
            :open="!data.use_event_custom_attribute"
            class="mb-2">
            <template v-slot:label>
                Use custom attribute value from trigger event
            </template>

            <vx-label>Membership Status</vx-label>
            <vx-input size="lg"
                type="text"
                placeholder="e.g., bronze, silver, gold"
                v-model="data.membership_status"
                :maxlength="40"
                :error="displayFirstError(validate.membership_status)">
            </vx-input>
        </toggle-action-data>
    </div>
</template>

<script setup>
import { VxInput, VxLabel } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { helpers, requiredIf, maxLength } from '@vuelidate/validators';
import { displayFirstError } from '~/utils/validation';
import ToggleActionData from './ToggleActionData.vue';

const data = defineModel();

if (data.value.use_event_custom_attribute === undefined) {
    data.value.use_event_custom_attribute = false;
}

const validate = useVuelidate({
    membership_status: {
        requiredIf: helpers.withMessage('Membership status is required when not using event custom attribute',
            requiredIf(() => !data.value.use_event_custom_attribute)),
        maxLength: helpers.withMessage('Membership status must be 40 characters or less', maxLength(40))
    }
}, data);
</script>
